enum RoleEnum {
  SYSADMIN = 'sysadmin',
  ADMIN = 'admin',
  EDITOR = 'editor',
  VIEWER = 'viewer',
}

export default RoleEnum;
